// ── Sound & Notification Manager ──
// Handles foreground sound/vibration, background browser notifications, and audio autoplay unlock

const SOUNDS = {
  call: null,
  message: null,
  outgoing: null,
};

let audioUnlocked = false;

// ── Audio autoplay unlock (must happen on first user interaction) ──
export function unlockAudio() {
  if (audioUnlocked) return;
  const handler = () => {
    // Create and immediately play a silent audio to unlock the context
    const silent = new Audio();
    silent.volume = 0;
    silent.play().catch(() => {});
    // Pre-load sounds
    SOUNDS.call = new Audio('/sounds/call.wav');
    SOUNDS.call.loop = true;
    SOUNDS.call.load();
    SOUNDS.message = new Audio('/sounds/message.wav');
    SOUNDS.message.load();
    SOUNDS.outgoing = new Audio('/sounds/outgoing.wav');
    SOUNDS.outgoing.loop = true;
    SOUNDS.outgoing.load();
    audioUnlocked = true;
    document.removeEventListener('click', handler);
    document.removeEventListener('touchstart', handler);
    document.removeEventListener('keydown', handler);
  };
  document.addEventListener('click', handler, { once: false });
  document.addEventListener('touchstart', handler, { once: false });
  document.addEventListener('keydown', handler, { once: false });
}

// ── Ensure sound objects exist (lazy init) ──
function getSound(type) {
  if (!SOUNDS[type]) {
    if (type === 'call') {
      SOUNDS.call = new Audio('/sounds/call.wav');
      SOUNDS.call.loop = true;
    } else if (type === 'message') {
      SOUNDS.message = new Audio('/sounds/message.wav');
    } else if (type === 'outgoing') {
      SOUNDS.outgoing = new Audio('/sounds/outgoing.wav');
      SOUNDS.outgoing.loop = true;
    }
  }
  return SOUNDS[type];
}

// ── Play ringtone (looping) ──
export function playRingtone() {
  const ringtone = getSound('call');
  ringtone.currentTime = 0;
  ringtone.loop = true;
  ringtone.play().catch(() => {
    console.warn('[Sound] Ringtone autoplay blocked');
  });
}

// ── Stop ringtone ──
export function stopRingtone() {
  const ringtone = SOUNDS.call;
  if (ringtone) {
    ringtone.pause();
    ringtone.currentTime = 0;
  }
}

// ── Play outgoing call tone (looping) ──
export function playOutgoingTone() {
  const tone = getSound('outgoing');
  tone.currentTime = 0;
  tone.loop = true;
  tone.play().catch(() => {
    console.warn('[Sound] Outgoing tone autoplay blocked');
  });
}

// ── Stop outgoing tone ──
export function stopOutgoingTone() {
  const tone = SOUNDS.outgoing;
  if (tone) {
    tone.pause();
    tone.currentTime = 0;
  }
}

// ── Play message sound (once) ──
export function playMessageSound() {
  const sound = getSound('message');
  sound.currentTime = 0;
  sound.play().catch(() => {
    console.warn('[Sound] Message sound autoplay blocked');
  });
}

// ── Vibrate (pattern fills ~2s to match interval) ──
export function vibrateCall() {
  if ('vibrate' in navigator) {
    navigator.vibrate([300, 100, 300, 100, 300, 100, 300, 100, 300]);
  }
}

export function vibrateMessage() {
  if ('vibrate' in navigator) {
    navigator.vibrate(200);
  }
}

export function stopVibration() {
  if ('vibrate' in navigator) {
    navigator.vibrate(0);
  }
}

// ── Is app in foreground? ──
export function isAppVisible() {
  return document.visibilityState === 'visible';
}
